var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.064 3.185l-1.6-.932L16.42 1.05l-1.6-.902c-.563-.33-1.036-.09-1.036.542v6.162c0 .662.473.933 1.036.602l1.6-.932 2.043-1.203 1.6-.931c.563-.331.563-.872 0-1.203M4.456 26.993l1.6.932L8.1 29.127l1.6.902c.562.331 1.035.09 1.035-.54v-6.164c0-.66-.473-.932-1.036-.6l-1.599.931c-.563.331-1.48.872-2.044 1.202l-1.6.932c-.562.331-.562.872 0 1.203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.167 4.037c1.617 0 3.192.355 4.683 1.056l.338.16 1.444-1.629-.581-.29a12.982 12.982 0 0 0-5.884-1.406C5.906 1.928 0 7.834 0 15.095c0 2.585.757 5.092 2.188 7.253l.36.542 1.449-1.634-.198-.318a10.988 10.988 0 0 1-1.69-5.843c0-6.098 4.96-11.058 11.058-11.058M22.802 6.15l-.375-.402-1.401 1.582.302.332a11.016 11.016 0 0 1 2.896 7.433c0 6.097-4.96 11.057-11.057 11.057-1.605 0-3.17-.347-4.61-1.015l-3.12.595a13.054 13.054 0 0 0 7.73 2.529c7.26 0 13.166-5.906 13.166-13.166 0-3.316-1.254-6.493-3.531-8.944"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncCloudIcon);
export default __webpack_public_path__ + "static/media/sync-cloud-icon.7bdc00fe281ce98ebdcd2594a7a7cd8a.svg";
export { ForwardRef as ReactComponent };